<template>
  <button @click.stop="click" class="timed-button" :disabled="disabled">
    <template v-if="waiting && confirmtext">{{confirmtext}}</template>
    <i v-else-if="waiting" class="fa fa-fw fa-check"></i>
    <template v-else-if="actiontext">{{actiontext}}</template>
    <i v-else class="fa fa-fw" :class="actionicon"></i>
  </button>
</template>

<script>
export default {
  name: 'TimedButton',
  props: {
    time: {
      required: false,
      default: 1500
    },
    actionicon: {
      required: false,
      default: 'fa-trash'
    },
    actiontext: {
      required: false,
      default: null
    },
    confirmtext: {
      required: false,
      default: null
    },
    disabled: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      waiting: false
    }
  },
  methods: {
    click () {
      if (this.waiting) {
        this.$emit('confirm')
      } else {
        this.start()
      }
    },
    start () {
      this.timeout = setTimeout(this.end, this.time)
      this.waiting = true
    },
    end () {
      this.waiting = false
    }
  },
  beforeDestroy () {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/_vars.scss';

</style>
